export enum ELocalStorageKeys {
	STATE = 'bodil-state',
	account = 'bodil-account',
}
